import React, { useState, useEffect, useRef } from 'react';
import { Button, Popper, Paper, Box, Typography, ClickAwayListener } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import GetAppIcon from '@material-ui/icons/GetApp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import useStyles from './style';
import Dropdown from './Dropdown';
import SimpleTableViewer from '../SimpleTable';
import OverviewCardViewer from '../OverviewCard';
import SpendCardViewer from './SpendCard';
import HeadingBarViewer from '../HeadingBar';
import ExternalFilter from './ExternalFilter';

const SpendViewer = (props) => {
    const classes = useStyles();
    const { spendDetails } = props;
    const [filterData, setFilterData] = useState({
    });
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [sort, setSort] = useState({});
    const [filterButtonText, setFilterButtonText] = useState('Filter by');
    const [savedFilterData, setSavedFilterData] = useState(null);

    const [tableData, setTableData] = useState({
    });

    useEffect(() => {
        const currentConditions = getConditions();
        props.getSpendDetails({
            appId: props.match.params.appid,
            dataModelId: spendDetails.dataModelId,
            mainDataModelId: spendDetails.mainDataModelId,
            documentId: props.match.params.id,
            dataUniqueId: props.data?.chartUniqueId + '_spendDetails_tableData',
            conditions: currentConditions,
            fields: "documentId",
            sort: sort,
            payload: {
                dataModelId: spendDetails.dataModelId,
                mainDataModelId: spendDetails.mainDataModelId,
                documentId: props.match.params.id,
                conditions: currentConditions,
                fields: "documentId",
                sort: sort,
                page: page,
                rowsPerPage: rowsPerPage
            }
        });
        props.getSpendFilters({
            appId: props.match.params.appid,
            dataModelId: spendDetails.dataModelId,
            dataUniqueId: props.data?.chartUniqueId + '_spendDetails_filterData',
            payload: {
                field: spendDetails?.spendInformation?.filter?.map(item => item.value).join(","),
                obligationId: props.match.params.id,
                mainDataModelId: spendDetails.mainDataModelId
            }
        });
        updateFilterCalculations();
    }, [props.activeTabMain]);

    useEffect(() => {
        if (props.formData?.document[props.data?.chartUniqueId + '_spendDetails_tableData']) {
            setTableData(props.formData?.document[props.data?.chartUniqueId + '_spendDetails_tableData'] || {});
            Object.keys(props.formData?.document[props.data?.chartUniqueId + '_spendDetails_tableData']).forEach(key => {
                let dataElement = spendDetails?.uploadCard?.dataElement.find(item => item.value === key);
                console.log('SpendViewer**dataElement', dataElement)
                if (dataElement) {
                    setCardData(prev => ({
                        ...prev,
                        [key]: props.formData?.document[props.data?.chartUniqueId + '_spendDetails_tableData']?.[dataElement.value] || ''
                    }));
                }
            });
        }
    }, [props.formData?.document[props.data?.chartUniqueId + '_spendDetails_tableData']])

    useEffect(() => {
        if (props.formData?.document[props.data?.chartUniqueId + '_spendDetails_filterData']) {
            setFilterData(props.formData?.document[props.data?.chartUniqueId + '_spendDetails_filterData'] || {});
        }
    }, [props.formData?.document[props.data?.chartUniqueId + '_spendDetails_filterData']])

    // Prefill filters from props.blockState on initial load   NLYAD
    useEffect(() => {
        // Only run if filterData is available, we haven't prefilled yet, and blockState exists
        if (Object.keys(filterData).length > 0 && !hasPrefilledFilters.current && props.blockState) {
            const prefilledFilters = {};
            const filterKeys = spendDetails?.spendInformation?.prefillFilters;
            let hasPrefilledValues = false;

            filterKeys.forEach(filterKey => {
                const blockStateValue = props.blockState[filterKey];
                if (blockStateValue !== undefined && blockStateValue !== null && blockStateValue !== '') {
                    // Get available options for this filter
                    const availableOptions = filterData[filterKey] || [];

                    // Convert blockState value to array format expected by ExternalFilter
                    // Handle both single values and arrays
                    const valuesToSet = Array.isArray(blockStateValue) ? blockStateValue : [blockStateValue];

                    // Map values to the format expected by ExternalFilter { label, value }
                    const mappedValues = valuesToSet.map(value => {
                        // Try to find matching option in filterData
                        const matchingOption = availableOptions.find(option => {
                            const optionValue = typeof option === 'object' ? option.value : option;
                            const optionLabel = typeof option === 'object' ? option.label : option;
                            return optionValue === value || optionLabel === value || String(optionValue) === String(value);
                        });

                        if (matchingOption) {
                            // Use the format from filterData
                            return typeof matchingOption === 'object'
                                ? { label: matchingOption.label, value: matchingOption.value }
                                : { label: matchingOption, value: matchingOption };
                        } else {
                            // If no match found, create object from the value
                            const isNumeric = typeof value === 'number' || (value != null && value !== '' && !isNaN(Number(value)));
                            const numVal = typeof value === 'number' ? value : Number(value);
                            return {
                                label: isNumeric ? numVal : (value ?? ''),
                                value: isNumeric ? numVal : String(value ?? '')
                            };
                        }
                    });

                    if (mappedValues.length > 0) {
                        prefilledFilters[filterKey] = mappedValues;
                        hasPrefilledValues = true;
                    }
                }
            });

            // Only set if we have prefilled values
            if (hasPrefilledValues) {
                hasPrefilledFilters.current = true;
                setLocalSelectedFilterData(prefilledFilters);
                setSavedFilterData(prefilledFilters);

                // Convert to conditions format and set selectedFilters
                const conditions = convertFilterValuesToConditions(prefilledFilters);
                setSelectedFilters(conditions);
            }
        }
    }, [filterData, props.blockState])

    const [cardData, setCardData] = useState({});
    const [selectedDocumentIds, setSelectedDocumentIds] = useState([]);

    console.log('SpendViewer**props', props, cardData)


    // State to track selected conditions for each filter
    const [selectedFilters, setSelectedFilters] = useState({});
    // State to control filter popper
    const [anchorEl, setAnchorEl] = useState(null);
    // Temporary state for filters in popper (before saving)
    const [localSelectedFilterData, setLocalSelectedFilterData] = useState(null);
    // Ref to track if filters have been prefilled from blockState
    const hasPrefilledFilters = useRef(false);
    
    // Handle selection change for a specific filter
    const handleSelectionChange = (condition) => {
        if (condition && condition.selectedConditionDataElement) {
            const filterKey = condition.selectedConditionDataElement;
            setSelectedFilters(prev => ({
                ...prev,
                [filterKey]: condition
            }));
            // Log or use the condition object as needed
            console.log('Condition:', condition);
        }
    };

    // Handle clear all for a specific filter
    const handleClearAll = (filterKey) => {
        setSelectedFilters(prev => ({
            ...prev,
            [filterKey]: null
        }));
    };
    // Handle opening filter popper
    const handleFilterClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    // Handle closing filter popper
    const handleFilterClose = (action) => {
        updateFilterCalculations();
        if (action === 'save') {
            // Convert ExternalFilter format to conditions format
            const conditions = convertFilterValuesToConditions(localSelectedFilterData || {});
            setSavedFilterData(localSelectedFilterData);
            setSelectedFilters(conditions);
            updateFilterCalculations();
        } else if (action === 'clear') {
            setLocalSelectedFilterData(null);
            setSavedFilterData(null);
            setSelectedFilters({});
            updateFilterCalculations();
        } else if (action === 'close') {
            const filters = savedFilterData ? savedFilterData : null;
            // Reset local filter data when closing without saving
            setLocalSelectedFilterData(filters);
        }
        setAnchorEl(null);
    };

    // Convert ExternalFilter values to conditions format
    const convertFilterValuesToConditions = (filterValues) => {
        const conditions = {};
        spendDetails?.spendInformation?.filter?.forEach((item) => {
            const filterValue = filterValues[item.value];
            if (filterValue && filterValue.length > 0) {
                conditions[item.value] = {
                    selectedConditionDataElement: item.value,
                    selectedConditionOperator: "in",  // equals
                    value: filterValue.map(v => v.value || v),
                    selectedConditionClause: "and"
                };
            } else {
                conditions[item.value] = null;
            }
        });
        return conditions;
    };

    // Handle external filter change
    const handleExternalFilterChange = (updatedFilters) => {
        setLocalSelectedFilterData(updatedFilters);
    };

    // Check if there are any filter values selected
    const hasLocalFilterValues = () => {
        if (!localSelectedFilterData) return false;
        return Object.values(localSelectedFilterData).some(filter =>
            filter && Array.isArray(filter) && filter.length > 0
        );
    };

    // Get all conditions in the required format
    const getConditions = () => {
        return Object.values(selectedFilters)
            .filter(condition => condition && condition.value && condition.value.length > 0);
    };

    const calculateSelectedFiltersCount = () => {
        const filterValues = localSelectedFilterData !== null ? localSelectedFilterData : {}

        if (!filterValues) return 0;

        let totalCount = 0;
        Object.values(filterValues).forEach((value) => {
            if (value && Array.isArray(value) && value.length > 0) {
                // String/namepicker filters - count each selected item
                totalCount += value.length;
            } else if (
                value &&
                typeof value === 'object' &&
                (value.startDate || value.endDate)
            ) {
                // Date range filter - count as 1 if any date is selected
                if (value.startDate || value.endDate) {
                    totalCount += 1;
                }
            } else if (
                value &&
                Array.isArray(value) &&
                value.length === 2 &&
                typeof value[0] === 'number' &&
                typeof value[1] === 'number'
            ) {
                // Number range filter - count as 1 if range is set
                totalCount += 1;
            }
        });
        return totalCount;
    };

    const updateFilterCalculations = () => {
        const selectedFiltersCount = calculateSelectedFiltersCount();
        const filterButtonText = selectedFiltersCount > 0 ? `Filter added (${selectedFiltersCount})` : 'Filter by';
        setFilterButtonText(filterButtonText);
    };

    // Log conditions whenever they change
    useEffect(() => {
        updateFilterCalculations();
        const conditions = Object.values(selectedFilters)
            .filter(condition => condition && condition.value && condition.value.length > 0);
        props.getSpendDetails({
            appId: props.match.params.appid,
            dataModelId: spendDetails.dataModelId,
            mainDataModelId: spendDetails.mainDataModelId,
            documentId: props.match.params.id,
            dataUniqueId: props.data?.chartUniqueId + '_spendDetails_tableData',
            conditions: conditions,
            fields: "documentId",
            sort: sort,
            payload: {
                dataModelId: spendDetails.dataModelId,
                mainDataModelId: spendDetails.mainDataModelId,
                documentId: props.match.params.id,
                conditions: conditions,
                fields: "documentId",
                sort: sort
            }
        });
        if (conditions.length > 0) {
            console.log('All Conditions:', conditions);
        }
    }, [selectedFilters]);

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
        const currentConditions = getConditions();
        props.getSpendDetails({
            appId: props.match.params.appid,
            dataModelId: spendDetails.dataModelId,
            mainDataModelId: spendDetails.mainDataModelId,
            documentId: props.match.params.id,
            dataUniqueId: props.data?.chartUniqueId + '_spendDetails_tableData',
            conditions: currentConditions,
            fields: "documentId",
            sort: sort,
            payload: {
                dataModelId: spendDetails.dataModelId,
                mainDataModelId: spendDetails.mainDataModelId,
                documentId: props.match.params.id,
                conditions: currentConditions,
                fields: "documentId",
                sort: sort,
                page: newPage,
                rowsPerPage: rowsPerPage
            }
        });
    };

    const handleRowsPerPageChange = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0); // Reset to first page when rows per page changes
        const currentConditions = getConditions();
        props.getSpendDetails({
            appId: props.match.params.appid,
            dataModelId: spendDetails.dataModelId,
            mainDataModelId: spendDetails.mainDataModelId,
            documentId: props.match.params.id,
            dataUniqueId: props.data?.chartUniqueId + '_spendDetails_tableData',
            conditions: currentConditions,
            fields: "documentId",
            sort: sort,
            payload: {
                dataModelId: spendDetails.dataModelId,
                mainDataModelId: spendDetails.mainDataModelId,
                documentId: props.match.params.id,
                conditions: currentConditions,
                fields: "documentId",
                sort: sort,
                page: 0, // Reset to first page
                rowsPerPage: newRowsPerPage
            }
        });
    };

    const handleDownload = () => {
        // Handle download for selected rows
        const isDownloadV2Call = checkDownloadV2Call(spendDetails?.spendInformation, tableData?.totalRecords);

        console.log('Download selected rows', selectedDocumentIds);
        if (selectedDocumentIds.length === 0) {
            console.warn('No documents selected');
            return;
        }
        let payload = {
            dataModelId: spendDetails.dataModelId,
            appid: props.match.params.appid,
            fields: spendDetails?.spendInformation?.dataElement.map(i => i.value).join(","),
            downloadType: 'excel',
            conditions: getConditions(),
            ids: selectedDocumentIds,
            dataUniqueId: props.data.chartUniqueId + '_' + 'selected_spend_download',
            isVisible: true,
            key: "xlsx",
            name: "Excel",
            _id: "",
            isDownloadV2Call: isDownloadV2Call
        }
        props.downloadSheet(payload);
        // Clear selected checkboxes after download
        setSelectedDocumentIds([]);
    };

    const handleSingleRowDownload = (e, rowData) => {
        // Handle download for a single row
        const rowId = rowData?.id || rowData?._id;
        if (!rowId) {
            console.warn('No document ID found in row data');
            return;
        }
        let payload = {
            dataModelId: spendDetails.dataModelId,
            appid: props.match.params.appid,
            fields: spendDetails?.spendInformation?.dataElement.map(i => i.value).join(","),
            downloadType: 'excel',
            conditions: getConditions(),
            ids: [rowId],
            dataUniqueId: props.data.chartUniqueId + '_' + 'single_row' + '_download',
            isVisible: true,
            key: "xlsx",
            name: "Excel",
            _id: "",
        }
        props.downloadSheet(payload);
    };

    const DEFAULT_EXPECTED_RULE_SIZE = 500;
    const checkDownloadV2Call = (spendInformation, totalRecords) => {
        return spendInformation.download?.v2 && (totalRecords >= (spendInformation.download?.expectedRuleSize || DEFAULT_EXPECTED_RULE_SIZE));
    };

    const handleDownloadAll = () => {
        const currentConditions = getConditions();
        const isDownloadV2Call = checkDownloadV2Call(spendDetails?.spendInformation, tableData?.totalRecords);
        let payload = {
            dataModelId: spendDetails.dataModelId,
            appid: props.match.params.appid,
            fields: spendDetails?.spendInformation?.dataElement.map(i => i.value).join(","),
            downloadType: 'excel',
            conditions: [{
                selectedConditionClause: "and",
                selectedConditionDataElement: "documentId",
                selectedConditionOperator: "equals",
                value: props.blockState['documentId']
            }, ...currentConditions],
            dataUniqueId: props.data.chartUniqueId + '_' + 'all_spend_download',
            isVisible: true,
            key: "xlsx",
            name: "Excel",
            _id: "",
            isDownloadV2Call: isDownloadV2Call
        }
        props.downloadSheet(payload);
    };

    const handleSortChange = (newSort) => {
        setSort(newSort);
        setPage(0); // Reset to first page when sort changes
        const currentConditions = getConditions();
        props.getSpendDetails({
            appId: props.match.params.appid,
            dataModelId: spendDetails.dataModelId,
            mainDataModelId: spendDetails.mainDataModelId,
            documentId: props.match.params.id,
            dataUniqueId: props.data?.chartUniqueId + '_spendDetails_tableData',
            conditions: currentConditions,
            fields: "documentId",
            sort: newSort,
            payload: {
                dataModelId: spendDetails.dataModelId,
                mainDataModelId: spendDetails.mainDataModelId,
                documentId: props.match.params.id,
                conditions: currentConditions,
                fields: "documentId",
                sort: newSort,
                page: 0,
                rowsPerPage: rowsPerPage
            }
        });
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <OverviewCardViewer {...props} src={spendDetails?.overview?.src} title={spendDetails?.overview?.title} description={spendDetails?.overview?.description} />
            <SpendCardViewer
                {...props}
                data={spendDetails?.uploadCard?.dataElement}
                blockState={cardData}
                isLoading={props.formData?.[props.data?.chartUniqueId + '_spendDetails_tableData_loading'] || props.formData?.[props.data?.chartUniqueId + '_spendDetails_filterData_loading']}
            />
            <HeadingBarViewer {...props} title={props?.spendDetails?.spendInformationHeader?.title} buttonLabel={props?.spendDetails?.spendInformationHeader?.actionButton?.label} onButtonClick={() => { }} isAttachmentsButton={false} blockState={{}} enableWorkflow={true} data={{}} />
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end', alignItems: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end', alignItems: 'center', gap: '10px', marginRight: '12px' }}>
                    {spendDetails?.spendInformation?.filter && spendDetails?.spendInformation?.filter?.length > 0 && (
                        <Button
                            variant="contained"
                            endIcon={<ArrowDropDownIcon />}
                            onClick={handleFilterClick}
                            style={{
                                backgroundColor: '#1976d2',
                                color: 'white',
                                textTransform: 'none'
                            }}
                        >
                            {filterButtonText}
                        </Button>
                    )}
                </div>
                <div className={classes.buttonsContainer}>
                    {/* Commenting this below Button as they don't need selected rows download as per the requirement */}
                    {spendDetails?.spendInformation?.downloadSelected && <Button
                        className={classes.downloadButton}
                        startIcon={<GetAppIcon style={{ fontSize: '16px' }} />}
                        onClick={handleDownload}
                    >
                        Download Selected
                    </Button>
                    }
                    { spendDetails?.spendInformation?.downloadAll && <Button
                        className={classes.downloadButton}
                        startIcon={<GetAppIcon style={{ fontSize: '16px' }} />}
                        onClick={handleDownloadAll}
                        disabled={selectedDocumentIds.length > 0}
                    >
                        Download
                    </Button>}
                    {(props.formData?.[props.data?.chartUniqueId + '_spendDetails_tableData_loading'] || props.formData?.[props.data?.chartUniqueId + '_spendDetails_filterData_loading'] || props.formData?.[props.data?.chartUniqueId + '_all_spend_download_loading'] || props.formData?.[props.data?.chartUniqueId + '_single_row_download_loading']) && (
                        <CircularProgress className={classes.loader} size={20} />
                    )}
                </div>
            </div>
            <SimpleTableViewer {...props} title={spendDetails?.spendInformation?.title} dataObj={tableData?.data} selectedDataElement={[]} dataModel="66e8297ca40acb5c5c38248a" selectedTableDataElement={spendDetails?.spendInformation?.dataElement} isActionEnabled={spendDetails?.spendInformation?.actions?.enable} isObjectTable={spendDetails?.spendInformation?.actions?.isObjectTable} pagination={true} page={page} rowsPerPage={rowsPerPage} onPageChange={handlePageChange} onRowsPerPageChange={handleRowsPerPageChange} totalRecords={tableData?.totalRecords} onDownload={handleSingleRowDownload} isDownloadButton={true} isCheckbox={spendDetails?.spendInformation?.checkbox} sort={sort} onSortChange={handleSortChange} onCheckboxChange={(updatedSelection) => setSelectedDocumentIds(updatedSelection)} selectedRows={selectedDocumentIds} />

            {/* Filter Popper */}
            <Popper
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                style={{ zIndex: 2000 }}
            >
                <ClickAwayListener onClickAway={() => handleFilterClose('close')}>
                    <Paper
                        className={classes.filterPopper}
                    >
                        <Box style={{ padding: '20px' }}>
                            <Box style={{ marginBottom: '20px' }}>
                                <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '16px' }}>
                                    Filter
                                </Typography>
                                <ExternalFilter
                                    {...props}
                                    externalFilters={spendDetails?.spendInformation?.filter?.map(item => ({
                                        value: item.value,
                                        label: item.label,
                                        type: item.isDate ? 'date' : 'select'
                                    })) || []}
                                    externalFilterData={spendDetails?.spendInformation?.filter?.map((item, index) =>
                                        // (filterData?.[item.value] || []).map(option => ({ label: option, value: option }))
                                        (filterData?.[item.value] || []).map(option => {
                                            const isNumeric = typeof option === 'number' || (option != null && option !== '' && !isNaN(Number(option)));
                                            const numVal = typeof option === 'number' ? option : Number(option);

                                            return {
                                                label: isNumeric ? numVal : (option ?? ''),
                                                value: isNumeric ? numVal : String(option ?? '')
                                            };
                                        })
                                    )}
                                    externalFilterValues={localSelectedFilterData !== null ? localSelectedFilterData : {}}
                                    onExternalFilterChange={handleExternalFilterChange}
                                    setLocalSelectedFilterData={setLocalSelectedFilterData}
                                    localSelectedFilterData={localSelectedFilterData}
                                    align="vertical"
                                    isNewV1Theme={true}
                                    dataModelId={spendDetails.dataModelId}
                                    appId={props.match.params.appid}
                                    dataUniqueId={props.data?.chartUniqueId + '_spendDetails_filterData'}
                                    getModelDataDropDown={(payload) => {
                                        // Map to getSpendFilters format
                                        props.getSpendFilters({
                                            appId: payload.appId,
                                            dataModelId: payload.id,
                                            dataUniqueId: payload.dataUniqueId,
                                            payload: {
                                                field: payload.field,
                                                obligationId: props.match.params.id,
                                                mainDataModelId: spendDetails.mainDataModelId
                                            }
                                        });
                                    }}
                                    formData={props.formData}
                                    conditions={getConditions()}
                                />
                            </Box>
                            <Box style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                paddingTop: '16px',
                                borderTop: '1px solid #e0e0e0'
                            }}>
                                {spendDetails?.spendInformation?.filter && spendDetails?.spendInformation?.filter?.length > 0 && (
                                    <Button
                                        onClick={() => {
                                            const clearedFilters = {};
                                            spendDetails?.spendInformation?.filter?.forEach((item) => {
                                                clearedFilters[item.value] = null;
                                            });
                                            setLocalSelectedFilterData(clearedFilters);
                                            handleFilterClose('clear');
                                        }}
                                        // disabled={!hasLocalFilterValues()}
                                        style={{
                                            color: '#1976d2',
                                            textTransform: 'capitalize'
                                        }}
                                    >
                                        Clear All
                                    </Button>
                                )}
                                <div style={{ display: 'flex', gap: '10px', marginLeft: 'auto' }}>
                                    <Button
                                        onClick={() => handleFilterClose('close')}
                                        style={{
                                            color: '#1976d2',
                                            textTransform: 'capitalize',
                                            height: 32,
                                            boxSizing: 'border-box'
                                        }}
                                    >
                                        Close
                                    </Button>
                                    <Button
                                        onClick={() => handleFilterClose('save')}
                                        // disabled={!hasLocalFilterValues()}
                                        variant="contained"
                                        style={{
                                            backgroundColor: '#1976d2',
                                            color: 'white',
                                            textTransform: 'capitalize',
                                            height: 32,
                                            boxSizing: 'border-box'
                                        }}
                                    >
                                        Save
                                    </Button>
                                </div>
                            </Box>
                        </Box>
                    </Paper>
                </ClickAwayListener>
            </Popper>
        </div>
    )
};

export default SpendViewer;